import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const AddToListIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentcolor">
            {/* eslint-disable-next-line max-len */}
            <path d="M2.91666 12.917V12.0837H8.74999V12.917H2.91666ZM2.91666 9.58366V8.75033H12.0833V9.58366H2.91666ZM2.91666 6.25033V5.41699H12.0833V6.25033H2.91666ZM13.75 16.2503V12.917H10.4167V12.0837H13.75V8.75033H14.5833V12.0837H17.9167V12.917H14.5833V16.2503H13.75Z" fill="currentcolor"/>
        </svg>
    </IconWrapper>
));
